var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1618_1880",
    transform: "scale(0.0119048)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1618_1880",
    width: 84,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAFSgAwAEAAAAAQAAAFQAAAAARFKgQwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAdJJREFUeAHt28FNw0AQheEYONENB6iBAyUgURsiJVCAG6APjhw5YWbMrmStbOuttSMB+6+0dmK/jOIvYydS5NOJgQACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgjMAtM0Xdi8gaOBQMJ8sfWnzfsGJfstscC0h/MA9Wg7GJ+f5t6Z5QC1FtUEtzAzLqgqasI8Z7md9bvtu1brdplLmGuneen6YRvuukRSDxpMVUrIgSkgqREwVSkhB6aApEbAVKWEHJgCkhoBU5UScpWYt0LJfiNgNvzswQSzoUDDUnQmmA0F1ksN65v3t3pnWuLZ5uN+ct77ass3IfebI+MwDKPyBq+U0DJTiekvfUhzWeYvPh6VN+2dJo8DmHLt/xKUQcHUPnIZVCtHSga1i/KXcT3ZPMO2LSCDeglQtyHznupveUe166l3qo9ufjb9HG7g0r+kbPIPZktjUFtqplqgghogEFCSTgU1QCCgJJ0KaoBAQEk6FdQAgYCSdCqoAQIBJelUUAMEAkpWdCo3Laj+Aiq31aiYObeDCmZGql2voIJZi1jmF6hgljhHnxvqpU1u7z4KyOsQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECgEPgGQrpStImH8uQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.18b07358ba47f226ed211a1d985758c6.svg";
export { ForwardRef as ReactComponent };